const CircularProgress = ({
  percent,
  size = 160,
  strokeWidth = 15,
  color = "#008000",
  trackColor = "#e6e6e6",
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = Math.PI * radius * 1.5;
  const offset = circumference - (percent / 100) * circumference;

  // Determine color based on percentage value
  const getProgressColor = (value) => {
    if (value >= 0 && value <= 49) {
      return "#ff5b33"; // RED
    } else if (value >= 50 && value <= 79) {
      return "#cdac27ff"; // YELLOW
    } else if (value >= 80 && value <= 100) {
      return "#41cd31"; // GREEN
    }
    return color; // fallback to provided color prop
  };

  const progressColor = getProgressColor(percent);

  return (
    <svg width={size} height={size} style={{ transform: "rotate(135deg)" }}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={trackColor}
        fill="none"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={0}
      />

      {percent > 0 && (
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={progressColor}
          fill="none"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      )}

      <text
        x={size / 2}
        y={size / 2}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="1.5em"
        fontWeight="bold"
        fill="#000"
        transform={`rotate(-135 ${size / 2} ${size / 2})`}
      >
        {`${percent}%`}
      </text>
    </svg>
  );
};

export default CircularProgress;
